// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'

import Vue from 'vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import VueMoment from 'vue-moment'

// Eventbus
import './config/event-bus.js'

// Vuex Store
import Store from './store'

import 'babel-polyfill'
import mxDomain from '@/mixins/globals/mx-domain'
import mxAuth from '@/mixins/globals/mx-auth'
import mxEstados from '@/mixins/globals/mx-estados'
import mxDates from '@/mixins/globals/mx-dates'
import mxGlobal from '@/mixins/globals/mx-global'

// i18n
import messages from './config/i18n-config'

//
Vue.use(Vuetify)
Vue.use(VueI18n)
Vue.use(VueMoment)
Vue.config.productionTip = false

var datosPortalString = localStorage.getItem('datos-portal');
var idiomaUsuario = 'es'
if (datosPortalString !== null) {
  const datosPortalObjeto = JSON.parse(datosPortalString);
  idiomaUsuario = datosPortalObjeto.idiomaUsuario;
}

if (idiomaUsuario === 'E') { //Desde el erp se coloca E en dberp y erp2 porque no está configurado, si se configura, esto no haría falta
  idiomaUsuario = 'es'
}
// Crear instancia de VueI18n
const i18n = new VueI18n({
  locale: idiomaUsuario, // Establecer el idioma basado en idiomaUsuario
  messages // Establecer los mensajes de idioma
});

/* eslint-disable no-new */
Vue.mixin({
  mixins: [mxDomain, mxAuth, mxEstados, mxDates, mxGlobal]
})


new Vue({
  el: '#app',
  i18n,
  router,
  store: Store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js